import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/configuration/omnibus')({
  component: Outlet,
  head: () => ({ meta: [{ title: 'Omnibus Accounts' }] }),
});
